export default __webpack_public_path__ + "static/media/swiper-paginate-inner-right.b8baebe2.png";